export default __webpack_public_path__ + "static/media/SpiritualTonic.a96dff8799cefb4d83e7157f082947a8.webp";